<h2 i18n
    class="mb-5">Projects</h2>
@if (welcomeBlockVisible$ | async) {
  <cm-welcome-block (welcomeBlockHide)="onWelcomeBlockHide()"
                    class="mb-2">
  </cm-welcome-block>
}
@if (tablePermission$ | async; as tablePermission) {
  <p-table @animateDisplay
           [scTableSettings]="tableSettings"
           class="cm-project-list-table">
    @if (tablePermission.isManager) {
      <ng-template pTemplate="tools-panel-right">
        <p-button label="Create new Project"
                  i18n-label
                  (onClick)="newProjectDialog()"
                  styleClass="p-button-outlined">
        </p-button>
      </ng-template>
      <ng-template pTemplate="row-actions"
                   let-project>
        <p-button [disabled]="project.status !== inWorkStatus"
                  icon="fas fa-pen"
                  styleClass="p-button-text p-button-rounded"
                  pTooltip="Rename Project"
                  (onClick)="updateProjectDialog(project)"
                  i18n-pTooltip
                  tooltipPosition="top">
        </p-button>
        <p-button [disabled]="project.status !== inWorkStatus || project.plagiarismCheckStatus !== uncheckedPlagiarismCheckStatus"
                  icon="fas fa-trash"
                  styleClass="p-button-text p-button-rounded"
                  pTooltip="Remove Project"
                  (onClick)="remove(project.id)"
                  i18n-pTooltip
                  tooltipPosition="top">
        </p-button>
      </ng-template>
    }
  </p-table>
}